/** Build a tel: href for click-to-call links. */
export function phoneTelHref(phone) {
  if (!phone || typeof phone !== 'string') return null;
  const trimmed = phone.trim();
  if (!trimmed) return null;
  const digits = trimmed.replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : null;
}
